import React from 'react';
import { SpinnerStyled, SpinnerLabel } from '../Spinner/styles';

const LoaderComponent = () => {
  return (
    <div
     style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(255, 255, 255, 0.6)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999,
    }}
    >
      <SpinnerStyled spinnerTop="50%" spinnerLeft="50%" />
      <SpinnerLabel textTop="48%" textLeft="50%">Loading</SpinnerLabel>
    </div>
  );
};

export default LoaderComponent;
